var map = {
	"./ACU/Footer": [
		57710,
		408
	],
	"./Bath/Footer": [
		48940,
		4992
	],
	"./CQU/Footer": [
		55638,
		3516
	],
	"./City/Footer": [
		64942,
		2758
	],
	"./Conestoga/Footer": [
		41308,
		7266
	],
	"./Deakin/Footer": [
		68429,
		8955
	],
	"./Flinders/Footer": [
		64196,
		8340
	],
	"./GU/Footer": [
		93113,
		3179
	],
	"./JCU/Footer": [
		16355,
		2999
	],
	"./MQ/Footer": [
		69503,
		7953
	],
	"./MacEwan/Footer": [
		4725,
		5141
	],
	"./Melbourne/Footer": [
		92218,
		6692
	],
	"./Monash/Footer": [
		76252,
		3193
	],
	"./Murdoch/Footer": [
		45227,
		8651
	],
	"./ND/Footer": [
		43879,
		7117
	],
	"./Nanyang/Footer": [
		1117,
		6285
	],
	"./Newcastle/Footer": [
		59015,
		2103
	],
	"./Purdue/Footer": [
		52706,
		6346
	],
	"./QUT/Footer": [
		17199,
		9319
	],
	"./RMIT/Footer": [
		62669,
		1423
	],
	"./Sydney/Footer": [
		14505,
		6947
	],
	"./UC/Footer": [
		2669,
		4411
	],
	"./UOW/Footer": [
		83872,
		7514
	],
	"./UQ/Footer": [
		46215,
		5769
	],
	"./USC/Footer": [
		75152,
		2170
	],
	"./UTS/Footer": [
		92435,
		5959
	],
	"./UWA/Footer": [
		8330,
		6276
	],
	"./UWS/Footer": [
		67228,
		4758
	],
	"./UniSA/Footer": [
		40447,
		6151
	],
	"./VU/Footer": [
		82848,
		8332
	],
	"./angliss/Footer": [
		86152,
		8990
	],
	"./conestogatest/Footer": [
		59780,
		8218
	],
	"./demo/Footer": [
		60054,
		2594
	],
	"./demous/Footer": [
		14846,
		6074
	],
	"./future/Footer": [
		65326,
		5282
	],
	"./gcu/Footer": [
		73152,
		4314
	],
	"./glos/Footer": [
		83176,
		4848
	],
	"./gordon/Footer": [
		91956,
		6552
	],
	"./icon/Footer": [
		92,
		6480
	],
	"./local/Footer": [
		394,
		1176
	],
	"./stagingQUT/Footer": [
		79972,
		4900
	],
	"./strath/Footer": [
		79539,
		6853
	],
	"./uk/Footer": [
		56053,
		3251
	],
	"./utsc/Footer": [
		83726,
		4958
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 31179;
module.exports = webpackAsyncContext;